import { Settings } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const SettingsIcon = (props: SvgIconProps) => (<Settings {...props}/>);